// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__0CvOI","row":"default_row__c1ICF","link":"default_link__2pWOT"};